var unescape = function (str) {
    return (str + '==='.slice((str.length + 3) % 4))
        .replace(/-/g, '+')
        .replace(/_/g, '/');
};
export var base64UrlDecode = function (input) {
    if (input === void 0) { input = ''; }
    var paddedBase64 = unescape(input);
    var decoded = atob(paddedBase64); // Decode base64 string using atob()
    return decoded;
};
